import { render, staticRenderFns } from "./Question12.vue?vue&type=template&id=577ef257&scoped=true&"
import script from "./Question12.vue?vue&type=script&lang=js&"
export * from "./Question12.vue?vue&type=script&lang=js&"
import style0 from "./Question12.vue?vue&type=style&index=0&id=577ef257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ef257",
  null
  
)

export default component.exports